let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("R3bvP")).then(() => parcelRequire('d8ZiM'));